import InsertNode from '../nodes/dataframes/types/insert';
import SelectNode from '../nodes/dataframes/types/select';
import UpdateNode from '../nodes/dataframes/types/update';

const dataframes = [
  {
    type: 'insert',
    title: 'Insert Node',
    node: InsertNode,
  },
  {
    type: 'select',
    title: 'Select Node',
    node: SelectNode,
  },
  {
    type: 'update',
    title: 'Update Node',
    node: UpdateNode,
  },
];

export default dataframes;
